module.exports = __webpack_public_path__ + "img/mask-no-data.00a51ef1.png";